<template>
  <v-app class="client-app">
    <v-navigation-drawer v-model="showMobileMenu"
                         v-if="pageWidth < 1200"
                         app
                         disable-resize-watcher>

      <v-list nav class="text-left mobile-nav-list">
        <v-list-item link
                     exact
                     :to="{name: 'home'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link
                     exact
                     :to="{name: 'about'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.about_us') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content class="p-0">
            <v-expansion-panels flat v-model="mobileFacilityPanel">
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('header.facility') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <div class="mobileMenuFacilityGroup">
                      <span class="mobileMenuFacilityGroupTitle">{{ $t('header.facilityOther') }}</span>
                      <div class="mobileMenuFacilityGroup">
                        <v-list-item v-for="(facilityType, index) in filteredFacilities.otherFacilities"
                                     :key="facilityType.id"
                                     :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}"
                                     link exact>
                          {{ facilityType.name }}
                        </v-list-item>
                      </div>
                    </div>
                  </v-list>
                  <v-list>
                    <div class="mobileMenuFacilityGroup">
                      <span class="mobileMenuFacilityGroupTitle">{{ $t('header.facilityHall') }}</span>
                      <div class="mobileMenuFacilityGroup">
                        <v-list-item v-for="(facilityType, index) in filteredFacilities.hallFacilities"
                                     :key="facilityType.id"
                                     :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}"
                                     link exact>
                          {{ facilityType.name }}
                        </v-list-item>
                      </div>
                    </div>
                  </v-list>
                  <v-list>
                    <div class="mobileMenuFacilityGroup">
                      <span class="mobileMenuFacilityGroupTitle">{{ $t('header.facilityRoom') }}</span>
                      <div class="mobileMenuFacilityGroup">
                        <v-list-item v-for="(facilityType, index) in filteredFacilities.roomFacilities"
                                     :key="facilityType.id"
                                     :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}"
                                     link exact>
                          {{ facilityType.name }}
                        </v-list-item>
                      </div>
                    </div>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content class="p-0">
            <v-expansion-panels flat v-model="mobileEventPanel">
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('header.event') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list-item v-for="(category, index) in categories"
                               :key="category.id"
                               :to="{name: 'event-list', params: {categoryId: category.id}}"
                               link exact>
                    {{ category.name }}
                  </v-list-item>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link
                     exact
                     :to="{name: 'pricing-info'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.pricing_info') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link
                     exact
                     :to="{name: 'past-event'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('past_event.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link
                     exact
                     :to="{name: 'promotion'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('promotion.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link
                     exact

                     v-if="!isLoggedIn"
                     :to="{name: 'login'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.login') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link
                     exact
                     v-if="!isLoggedIn"
                     :to="{name: 'register'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.register') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link
                     exact
                     v-if="isLoggedIn"
                     :to="{name: 'my-account'}"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>{{ $t('header.my_account') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$i18n.locale !== 'zh'"
                     @click="changeLocale('zh')"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>中</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$i18n.locale !== 'en'"
                     @click="changeLocale('en')"
                     class="single-level">
          <v-list-item-content>
            <v-list-item-title>EN</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Mobile App Bar -->
    <v-app-bar app
               v-if="pageWidth < 1200"
               flat
               elevate-on-scroll
               disable-resize-watcher
               disable-route-watcher
               height="96px"
               color="white"
               class="mobile-app-bar text-center">


      <v-app-bar-nav-icon @click.stop="showMobileMenu = !showMobileMenu"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <div class="mobile-app-bar-icons">
        <!--        <a :href="$t('home.hkaa_link')" target="_blank">-->
        <!--          <v-img :src="require('../../assets/logo-hkaa.png')"-->
        <!--                 class="hkaa-logo"-->
        <!--                 contain></v-img>-->
        <!--        </a>-->
        <!--        <router-link :to="{name: 'home'}">-->
        <!--          <v-img :src="require('../../assets/logo-race.png')"-->
        <!--                 class="hkiarace-logo"-->
        <!--                 contain></v-img>-->
        <!--        </router-link>-->
        <router-link :to="{name: 'home'}">
          <v-img :src="require('../../assets/logo-new.png')"
                 max-height="75px"
                 max-width="250px"
                 contain></v-img>
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <v-badge v-if="isLoggedIn && accMembershipValid"
               color="red"
               overlap
               :content="shoppingCart? shoppingCart.bookings.length : ''"
               :value="shoppingCart? shoppingCart.bookings.length : false"
               class="shopping-cart-icon">
        <v-img :src="require('../../assets/cart.png')" width="24px"
               @click="$router.push({name: 'shopping-cart'})"
        ></v-img>
      </v-badge>
    </v-app-bar>
    <!-- Desktop App Bar -->
    <v-app-bar app
               v-if="pageWidth >= 1200"
               flat
               elevate-on-scroll
               disable-resize-watcher
               disable-route-watcher
               height="140px"
               color="white"
               class="desktop-app-bar">
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <!--      <a :href="$t('home.hkaa_link')" target="_blank">-->
      <!--        <img :src="require('../../assets/logo-hkaa.png')"-->
      <!--             class="hkaa-logo">-->
      <!--      </a>-->
      <!--      <router-link :to="{name: 'home'}">-->
      <!--        <img :src="require('../../assets/logo-race.png')"-->
      <!--             class="hkiarace-logo">-->
      <!--      </router-link>-->
      <router-link :to="{name: 'home'}">
        <v-img :src="require('../../assets/logo-new.png')"
               max-height="75px"
               max-width="300px"
               contain></v-img>
      </router-link>
      <v-spacer></v-spacer>

      <v-btn class="menu-btn" text exact :to="{name: 'home'}">
        {{ $t('header.home') }}
      </v-btn>
      <v-btn class="menu-btn" text exact :to="{name: 'about'}">
        {{ $t('header.about_us') }}
      </v-btn>
      <!--            <v-btn text color="primary" :to="{name: 'facility'}">-->
      <!--                {{$t('header.facility')}}-->
      <!--            </v-btn>-->
      <v-menu content-class="menu-container"
              v-model="showFacilityMenu"
              offset-y
              nudge-bottom="51"
              nudge-left="50%"
              max-width="1100px">
        <template v-slot:activator="{ on }">
          <v-btn class="menu-btn dropdown-menu-btn" text v-on="on" :class="{'v-btn--active': currentRouteName === 'facility'}">
            {{ $t('header.facility') }}
            <div class="down-arrow" v-if="showFacilityMenu">
              <div class="menu-item-arrow"/>
            </div>
          </v-btn>
        </template>
        <v-container id="facilityMenu" class="nav-menu-container" fluid>
          <v-row>
            <v-col class="facility-menu-container" md="8">
              <v-container id="facilitySubMenu" class="sub-menu-container">
                <v-row style="margin: 0">
                  <v-col>
                    <v-row class="facility-menu-item-wrapper" md="4">
                      <v-btn text block disabled
                             class="facility-menu-item title-font">
                        <span style="text-transform: uppercase;">{{ $t('header.facilityOther') }}</span>
                      </v-btn>
                    </v-row>
                    <v-row class="facility-menu-item-wrapper"
                           v-for="(facilityType, index) in filteredFacilities.otherFacilities"
                           :key="facilityType.id"
                           @mouseenter="facilityImageCarousel = facilityType.dataIndex"
                           md="4">
                      <!--<div class="facility-menu-item-wrapper" v-for="(facilityType, index) in facilityTypes" :key="facilityType.id" @mouseenter="facilityImageCarousel = index">-->
                      <!-- <v-col > -->
                      <v-btn text block
                             :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}"
                             class="facility-menu-item title-font">
                        {{ facilityType.name }}

                      </v-btn>
                      <!-- </v-col> -->
                      <!--</div>-->
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="facility-menu-item-wrapper" md="4">
                      <v-btn text block disabled
                             class="facility-menu-item title-font">
                        <span style="text-transform: uppercase;">{{ $t('header.facilityHall') }}</span>
                      </v-btn>
                    </v-row>
                    <v-row class="facility-menu-item-wrapper"
                           v-for="(facilityType, index) in filteredFacilities.hallFacilities"
                           :key="facilityType.id"
                           @mouseenter="facilityImageCarousel = facilityType.dataIndex"
                           md="4">
                      <!--<div class="facility-menu-item-wrapper" v-for="(facilityType, index) in facilityTypes" :key="facilityType.id" @mouseenter="facilityImageCarousel = index">-->
                      <!-- <v-col > -->
                      <v-btn text block
                             :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}"
                             class="facility-menu-item title-font">
                        {{ facilityType.name }}

                      </v-btn>
                      <!-- </v-col> -->
                      <!--</div>-->
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="facility-menu-item-wrapper" md="4">
                      <v-btn text block disabled
                             class="facility-menu-item title-font">
                        <span style="text-transform: uppercase;">{{ $t('header.facilityRoom') }}</span>
                      </v-btn>
                    </v-row>
                    <v-row class="facility-menu-item-wrapper"
                           v-for="(facilityType, index) in filteredFacilities.roomFacilities"
                           :key="facilityType.id"
                           @mouseenter="facilityImageCarousel = facilityType.dataIndex"
                           md="4">
                      <!--<div class="facility-menu-item-wrapper" v-for="(facilityType, index) in facilityTypes" :key="facilityType.id" @mouseenter="facilityImageCarousel = index">-->
                      <!-- <v-col > -->
                      <v-btn text block
                             :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}"
                             class="facility-menu-item title-font">
                        {{ facilityType.name }}

                      </v-btn>
                      <!-- </v-col> -->
                      <!--</div>-->
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col md="4" class="py-0">
              <b-carousel v-model="facilityImageCarousel"
                          :interval="0"
                          no-animation>
                <b-carousel-slide v-for="facilityType in facilityTypes"
                                  :key="facilityType.id"
                                  class="menu_carousel"
                                  :img-src="getURL(facilityType.banner)">
                </b-carousel-slide>
              </b-carousel>
            </v-col>
          </v-row>
        </v-container>
        <v-row>
          <div class="menuPricingInfoContainer">
            <v-btn text block
                   :to="{name: 'pricing-info'}"
                   class="title-font menuPricingInfoButton">
              {{ $t('header.pricing_info') }}
              <div class="menu-facilities-arrow"/>
            </v-btn>
          </div>
        </v-row>
      </v-menu>
      <v-menu content-class="menu-container"
              v-model="showEventMenu"
              offset-y
              nudge-bottom="51"
              nudge-left="50%"
              max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn class="menu-btn dropdown-menu-btn" text v-on="on" :class="{'v-btn--active': currentRouteName === 'event-list'}">
            {{ $t('header.event') }}
            <div class="down-arrow" v-if="showEventMenu">
              <div class="menu-item-arrow"/>
            </div>
          </v-btn>
        </template>
        <v-container id="eventMenu" class="nav-menu-container" fluid>
          <v-row>
            <v-col class="event-menu-container">
              <div class="event-menu-item-wrapper" v-for="(category, index) in categories" :key="category.id" @mouseenter="eventImageCarousel = index">
                <!-- <v-col > -->
                <v-btn text block
                       :to="{name: 'event-list', params: {categoryId: category.id}}"
                       class="event-menu-item title-font">
                  {{ category.name }}
                </v-btn>
                <!-- </v-col> -->
              </div>
              <div class="event-menu-item-wrapper" @mouseenter="eventImageCarousel = 3">
                <!-- <v-col> -->
                <v-btn text block
                       :to="{name: 'past-event'}"
                       class="event-menu-item title-font">
                  {{ $t('past_event.title') }}
                </v-btn>
                <!-- </v-col> -->
              </div>
            </v-col>
            <v-col class="py-0">
              <b-carousel v-model="eventImageCarousel"
                          :interval="0"
                          no-animation>
                <b-carousel-slide
                    class="menu_carousel"
                    :img-src="require('../../assets/menu_free_court.jpg')"
                ></b-carousel-slide>
                <b-carousel-slide
                    class="menu_carousel"
                    :img-src="require('../../assets/menu_seminar.jpg')"
                ></b-carousel-slide>
                <b-carousel-slide
                    class="menu_carousel"
                    :img-src="require('../../assets/menu_mega.jpg')"
                ></b-carousel-slide>
                <b-carousel-slide
                    class="menu_carousel"
                    :img-src="require('../../assets/menu_moment.jpg')"
                ></b-carousel-slide>
              </b-carousel>
            </v-col>
          </v-row>
        </v-container>
      </v-menu>
      <v-btn class="menu-btn" text :to="{name: 'promotion'}">
        {{ $t('promotion.title') }}
      </v-btn>

      <v-btn class="menu-btn" text :to="{name: 'login'}" v-if="!isLoggedIn">
        {{ $t('header.login') }}
      </v-btn>
      <v-btn class="menu-btn" text :to="{name: 'register', query: {t:1}}" v-if="!isLoggedIn">
        {{ $t('header.register') }}
      </v-btn>
      <v-btn class="menu-btn" text :to="{name: 'my-account'}" v-if="isLoggedIn">
        {{ $t('header.my_account') }}
      </v-btn>
      <v-btn class="menu-btn" text @click="changeLocale('zh')" v-if="$i18n.locale !== 'zh'">
        中
      </v-btn>
      <v-btn class="menu-btn" text @click="changeLocale('en')" v-if="$i18n.locale !== 'en'">
        EN
      </v-btn>
      <v-btn icon @click="$router.push({name: 'shopping-cart'})" v-if="isLoggedIn && accMembershipValid">
        <v-badge color="red"
                 :content="shoppingCart? shoppingCart.bookings.length : ''"
                 :value="shoppingCart? shoppingCart.bookings.length : false">
          <v-img :src="require('../../assets/cart.png')" width="24px"></v-img>
        </v-badge>
      </v-btn>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main class="mx-lg-8 mx-xl-12">

      <!-- Provides the application the proper gutter -->
      <v-container fluid class="p-0 d-flex flex-column fill-height">

        <!-- If using vue-router -->
        <router-view @toggleMenuFacility="toggleMenuFacility" @toggleMenuEvent="toggleMenuEvent"></router-view>
      </v-container>
    </v-main>
    <v-container class="footer" fluid>
      <v-container class="footer-container">
        <v-divider dark></v-divider>
        <v-row class="footer-nav">
          <div class="nav">
            <v-btn text class="footer-button" color="#919191" :to="{name: 'about'}">
              {{ $t('header.about_us') }}
            </v-btn>
            |
            <v-btn text class="footer-button" color="#919191" @click="toggleMenuFacility">
              {{ $t('header.facility') }}
            </v-btn>
            |
            <v-btn text class="footer-button" color="#919191" @click="toggleMenuEvent">
              {{ $t('header.event') }}
            </v-btn>
            |
            <v-btn text class="footer-button" color="#919191" :to="{name: 'promotion'}">
              {{ $t('promotion.title') }}
            </v-btn>
            |
            <v-btn text class="footer-button" color="#919191" :to="{name: 'pricing-info'}">
              {{ $t('header.pricing_info') }}
            </v-btn>
            |
            <v-btn text class="footer-button" color="#919191" :to="{name: 'sitemap'}">
              {{ $t('header.sitemap') }}
            </v-btn>
          </div>
          <!--<div class="social">-->
          <!--<v-btn icon color="#919191" class="float-right">-->
          <!--<v-icon>mdi-twitter</v-icon>-->
          <!--</v-btn>-->
          <!--<v-btn icon color="#919191" class="float-right">-->
          <!--<v-icon>mdi-image-multiple</v-icon>-->
          <!--</v-btn>-->
          <!--</div>-->
        </v-row>
        <v-divider dark></v-divider>
        <v-row class="footer-tnc">
          <div class="copyright font-size-40">
            {{ $t('header.allrights') }}
          </div>
          <div class="policy font-size-40">
            <a @click="getPrivacyPolicy">
              {{ $t('header.privacy') }}
            </a>
            |
            <a @click="getTNC">
              {{ $t('header.tnc') }}
            </a>
          </div>
        </v-row>
      </v-container>
    </v-container>

    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light v-if="tnc">
        <v-card-title class="tnc-title title-font">{{ tncDialogShownTnc ? tnc.title : tnc.privacy_title }}</v-card-title>

        <v-card-text v-html="tncDialogShownTnc ? tnc.content : tnc.privacy_content" class="text-left"></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>

          <v-btn text
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="tncDialogShown = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {DateTime, Settings} from 'luxon'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faBars, faBell, faTools, faSignOutAlt} from '@fortawesome/free-solid-svg-icons'

import {HOST} from '@/main'
import {ref, onBeforeMount, onMounted, computed, watch} from "@vue/composition-api";
import _ from "lodash";

library.add(faBars, faBell, faTools, faSignOutAlt);
export default {
  name: 'Client',
  setup(props, {root, emit}) {
    const checkMaintenance = function () {
      root.$callAPI('maintenance/', {}, function (response) {
        if (response.body.maintenance) {
          window.location = '/maintenance/';
        }
      }, function (response) {

      });
    }
    onBeforeMount(() => {
      // window.location.replace('https://hkiarace.com/register')
      // return

      checkMaintenance();

      // Set Locale if specified in query string
      const locale = root.$route.query.locale;
      if (locale) {
        root.$cookie.set('locale', locale, {samesite: 'Strict', secure: true})
        root.$i18n.locale = locale;
        Settings.defaultLocale = locale;

        let query = Object.assign({}, root.$route.query);
        delete query.locale;
        root.$router.push({path: root.$route.path, query: query})
      }
    });

    const isIE = function () {
      const userAgent = window.navigator.userAgent;
      const msie = userAgent.indexOf("MSIE ");

      return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./) || /Edge/.test(navigator.userAgent);
    }
    const pageWidth = ref(window.innerWidth);
    const facilityTypes = ref([]);
    const filteredFacilities = computed(() => {
      let dataIndex = 0;
      let hallFacilities = [];
      let roomFacilities = [];
      let otherFacilities = [];
      facilityTypes.value.map((f) => {
        if (f.name === 'Multi-purpose Sports Hall' || f.name === '體育及多用途活動廳') {

        } else if (f.name === 'Multi-purpose Hall' || f.name === '多用途活動廳') {
          hallFacilities.push({...f, dataIndex})
        } else if (f.name === 'Basketball Court' || f.name === '籃球場') {
          hallFacilities.push({...f, dataIndex})
        } else if (f.name === 'Badminton Court' || f.name === '羽毛球場') {
          hallFacilities.push({...f, dataIndex})
        } else if (f.name === 'Yoga Room' || f.name === '瑜伽室') {
          roomFacilities.push({...f, dataIndex})
        } else if (f.name === 'Table Tennis Room' || f.name === '乒乓球室') {
          roomFacilities.push({...f, dataIndex})
        } else if (f.name !== 'All Facilities (For Maintenance)' && f.name !== '類別所有設施 (維修停用)' ) {
          otherFacilities.push({...f, dataIndex})
        }

        dataIndex++;
      })

      return {hallFacilities, roomFacilities, otherFacilities}
    })
    const categories = ref([]);
    const currentRouteName = ref('');
    onMounted(() => {
      // Link Fonts for IE
      if (isIE()) {
        let head = document.getElementsByTagName('head')[0];
        let cssnode = document.createElement('link');

        cssnode.type = 'text/css';
        cssnode.rel = 'stylesheet';
        cssnode.href = 'https://fonts.googleapis.com/css?family=Montserrat|Roboto&display=swap';

        head.appendChild(cssnode);
      }

      root.$storeDispatch('getMe');
      root.$storeDispatch('getShoppingCart');

      const locale = root.$cookie.get('locale') || 'en';
      root.$cookie.set('locale', locale, {samesite: 'Strict', secure: true});
      root.$i18n.locale = locale;
      Settings.defaultLocale = locale;

      root.$nextTick(() => {
        window.addEventListener('resize', () => {
          pageWidth.value = window.innerWidth;
        });
      });

      root.$callAPI('aafb/facility_types/', {}, function (response) {
        facilityTypes.value = response.body.item_types;
      });
      root.$callAPI('hkiarace/event_category/', {}, function (response) {
        categories.value = response.body.categories;
      });

      root.$eventHub.$on('logout', () => {
        root.$router.push({name: 'login'});
      });

      currentRouteName.value = root.$router.history.current.name;
      root.$router.afterEach((to, from) => {
        currentRouteName.value = to.name;
      })
    });

    const showMobileMenu = ref(false);
    const mobileFacilityPanel = ref(null);
    const mobileEventPanel = ref(null);
    const showFacilityMenu = ref(false);
    const facilityImageCarousel = ref(0);
    const showEventMenu = ref(false);
    const eventImageCarousel = ref(0);
    const toggleMenuFacility = function () {
      if (pageWidth.value < 1200) {
        showMobileMenu.value = true
        mobileFacilityPanel.value = 0
        mobileEventPanel.value = null
      } else {
        showFacilityMenu.value = !showFacilityMenu.value
      }
    }
    const toggleMenuEvent = function () {
      if (pageWidth.value < 1200) {
        showMobileMenu.value = true
        mobileFacilityPanel.value = null
        mobileEventPanel.value = 0
      } else {
        showEventMenu.value = !showEventMenu.value
      }
    }
    const changeLocale = function (locale) {
      root.$cookie.set('locale', locale, {samesite: 'Strict', secure: true});
      window.location.reload();
    }

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return `${HOST}static/` + f;
      }
    }

    const tnc = ref(null);
    const tncDialogShown = ref(false);
    const tncDialogShownTnc = ref(false);
    const getPrivacyPolicy = function () {
      root.$callAPI('hkiarace/tnc/', {}, function (response) {
        tnc.value = response.body;
        tncDialogShown.value = true;
        tncDialogShownTnc.value = false;
      });
    }
    const getTNC = function () {
      root.$callAPI('hkiarace/tnc/', {}, function (response) {
        tnc.value = response.body;
        tncDialogShown.value = true;
        tncDialogShownTnc.value = true;
      });
    }

    const isLoggedIn = computed(() => !!root.$store.state.user.id);
    const currentUser = computed(() => root.$store.state.user);
    watch(() => currentUser.value, (newVal, oldVal) => {
      if (oldVal.id && !newVal.id) {
        root.$router.replace({name: 'home'});
      }
    })
    const accMembershipValid = computed(() => {
      if (!currentUser.value.acc_membership_valid_until) {
        return false;
      }

      return DateTime.fromISO(currentUser.value.acc_membership_valid_until) > DateTime.local();
    })
    const shoppingCart = computed(() => root.$store.state.shoppingCart);

    const banners = ref([]);
    const getBanners = function () {
      root.$callAPI('hkiarace/banners/', {}, (response) => {
        banners.value = response.body.banners;
        tryShowBanners()
      });
    }
    const tryShowBanners = function () {
      if (root.$route.path) {
        let filteredBanners = _.filter(banners.value, (b) => {
          // console.log(b.path, root.$route.path);

          return b.path === root.$route.path && b.require_login === isLoggedIn.value;
        });

        // console.log(filteredBanners);
        if (filteredBanners.length > 0) {
          root.$showBanners(filteredBanners);
        }
      }
    }

    onMounted(() => {
      getBanners()
    })
    watch(() => root.$route, () => {
      tryShowBanners();
    })

    return {
      pageWidth,
      facilityTypes,
      filteredFacilities,
      categories,
      currentRouteName,
      showMobileMenu,
      mobileFacilityPanel,
      mobileEventPanel,
      showFacilityMenu,
      facilityImageCarousel,
      showEventMenu,
      eventImageCarousel,
      toggleMenuFacility,
      toggleMenuEvent,
      changeLocale,
      getURL,
      tnc,
      tncDialogShown,
      tncDialogShownTnc,
      getPrivacyPolicy,
      getTNC,
      isLoggedIn,
      accMembershipValid,
      shoppingCart,
    }
  },
}
</script>

<style lang="less">
.client-app {

  .mobile-nav-list {
    .single-level {
      .v-list-item__content {
        padding: 16px 24px;
      }
    }
  }

  .mobile-app-bar {
    //width: 100vw !important;

    .shopping-cart-icon {
      cursor: pointer;
      z-index: 10;
    }

    .mobile-app-bar-icons {
      display: flex;
      flex: 0 0 0;
      //position: absolute;
      //width: 87%;
      justify-content: center;
      padding-right: 5%;
      z-index: 10;
      left: 10%;
    }

    .hkaa-logo {
      max-width: 6.8em;
      max-height: 4.1em;
    }

    .hkiarace-logo {
      margin-left: 15px;
      max-width: 4.3em;
      max-height: 3.3em;
    }
  }

  .desktop-app-bar {
    .v-btn--active {
      .v-btn__content::after {
        display: block;
        position: absolute;
        bottom: -5px;
        width: 100%;
        height: 1px;
        content: " ";
        border-bottom: 1px solid;
      }
    }

    .hkaa-logo {
      max-width: 10em;
      max-height: 7em;
    }

    .hkiarace-logo {
      margin-left: 20px;
      max-width: 6em;
      max-height: 5em;
    }

    .dropdown-menu-btn {
      position: relative;

      .down-arrow {
        position: absolute;
        bottom: -55px;

        width: 100%;
        display: flex;
        justify-content: center;

        .menu-item-arrow {
          // position: absolute;
          // bottom: -55px;
          width: 20px;
          height: 20px;
          overflow: hidden;
          box-sizing: border-box;
          transform: rotate(90deg);
        }

        .menu-item-arrow:before {
          content: "";
          position: absolute;
          top: 0;
          right: 75%;
          width: 100%;
          height: 100%;
          border: 1px solid rgba(43, 43, 43, 0.4);
          transform: rotate(45deg);
        }
      }
    }
  }

  .footer {
    background-color: #1a1f28;
    padding: 3rem 0 6rem 0;

    a {
      color: #616161;
    }

    .footer-container {
      padding: 0rem 1rem;
      max-width: none;

      @media only screen and (min-width: 700px) {
        padding: 0rem 2rem;
      }
      @media only screen and (min-width: 1200px) {
        padding: 0rem 14rem;
      }
      @media only screen and (min-width: 1700px) {
        padding: 0rem 20rem;
      }
    }
  }
}

#facilityMenu {
  background-color: white;
}

#eventMenu {
  background-color: white;
}

.menu_carousel {
  background-size: cover;

  img {
    object-fit: cover;
    height: 240px;
  }
}

.menu-container {
  border-radius: 0;
  box-shadow: none;
  width: 100%;
}

.nav-menu-container {


  .facility-menu-container, .event-menu-container {

    padding-top: 0 !important;
    padding-bottom: 0 !important;

    .sub-menu-container {
      padding: 0 !important;
    }
  }

  .facility-menu-item-wrapper, .event-menu-item-wrapper {
    padding: 0 !important;
    // &:hover {
    //   color: white;
    //   background-color: rgb(149, 125, 99);
    // }
    .v-btn__content {
      white-space: normal;
      max-width: 100%;
    }

    border-bottom: 1px solid rgb(239, 239, 239);
    margin-left: 4px;
    margin-right: 4px;
    justify-content: center;
  }

  .facility-menu-item, .event-menu-item {
    padding: 30px !important;
    color: inherit !important;
    background-color: inherit !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 400;
    font-size: 1rem;

    // &:hover {
    //   background-color: rgb(149, 125, 99);
    // }
    &:before {
      background: none;
    }

    &.v-btn--active {
      border-radius: 0;
      color: white !important;
      background-color: rgb(149, 125, 99) !important;
    }

    &.v-btn--disabled {
      border-radius: 0;
      color: black !important;
      font-weight: bolder;
      font-size: 14px;
      /*background-color: rgb(149, 125, 99) !important;*/
    }

    &:hover, &:focus {
      border-radius: 0;
      color: white !important;
      background-color: rgb(149, 125, 99) !important;
    }
  }

}

.mobileMenuFacilityGroup {
  padding: 6px;
}

.mobileMenuFacilityGroupTitle {
  font-weight: bolder;
  font-size: 14px;
  text-transform: uppercase;
}

.footer-button {
  font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
  text-transform: unset !important;
  letter-spacing: 0 !important;
  padding: 0 25px !important;

  .v-btn__content {
    color: rgb(170, 170, 170);
  }
}

.footer-nav {
  color: rgb(145, 145, 145);
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;

  @media only screen and (min-width: 1700px) {
    padding: 0px 38px;
  }

  .nav {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    align-items: center;
  }

  .social {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    align-items: center;
  }
}

.footer-tnc {
  color: #616161;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;

  .copyright {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    padding: 10px 0;
  }

  .policy {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    padding: 10px 0;

    a {
      margin: 0 20px;
    }
  }

  @media only screen and (max-width: 1200px) {
    flex-direction: column-reverse;
    .policy {
      justify-content: flex-start;
    }
  }
}

.v-application {
  .v-application--wrap {
    width: 100%;
  }
}

.v-content {
  .v-content__wrap {
    width: 100%;
  }
}

.tnc-dialog-card {
  margin: auto;

  .tnc-title {
    font-size: 1.5rem;
    letter-spacing: unset;
  }

  .v-card__text {
    border-top: 1px solid lightgrey;
    border-bottom: 1px solid lightgrey;
    height: calc(100% - 116px);
    overflow: scroll;
  }

  .tnc-actions {

    .tnc-action {
      text-transform: capitalize;
      letter-spacing: unset;
    }
  }
}

.menuPricingInfoContainer {
  width: 100%;
  background-color: #333435;

  .menuPricingInfoButton {
    color: #fff !important;
    height: 50px !important;
  }
}

.menu-facilities-arrow {
  margin-left: 1.3rem;
  width: 20px;
  height: 20px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.menu-facilities-arrow:before {
  content: "";
  position: absolute;
  top: 0;
  right: 75%;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.8);
  transform: rotate(45deg);
}

</style>
